export const INSIGHT_TYPES = {
  ACQUISITION_DECREASE: 'acquisition_decrease',
  ACQUISITION_INCREASE: 'acquisition_increase',
  ACQUISITION_PAUSE: 'acquisition_pause',
  ACQUISITION_MARKET_EXPANSION: 'acquisition_market_expansion',
};
